define(function(require, exports, module) {
    'use strict';

    // @ngInject
    exports.LoginService = function($http, $window, lpPortal, lpWidget, lpCoreUtils,$q) {

        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        // Login model
        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        var self = this;
        var config = {
            loginUrl: lpPortal.root + '/bb-public-api/security/login',
            otpValidationUrl: lpPortal.root + '/services/rest/v1/2fa-login',
            setPasswordUrl: lpPortal.root + '/services/rest/v1/password',
            getQrUrl: lpPortal.root + '/services/rest/v1/otp/activation',
            otpBindUrl: lpPortal.root + '/services/rest/v1/binding',
            logoutUrl: lpPortal.root + '/bb-public-api/security/logout',
            sessionAlive: lpPortal.root + '/services/rest/v1/public/handshake',
            optActivationUrl: lpPortal.root + '/services/rest/v1/otp/activation',
            userStatusUrl: lpPortal.root + '/services/rest/v1/user-status'
        };

        /**
         * Login
         */
        this.doLogin = function(userId, password, otp, token) {
          var promise = this.getLoginPromise(userId, password).success(function( response ) {
            self.error = null;

          }).error(function(response) {
              self.error = response.errors[0].code;

          });
          return promise;
        };

        this.getLoginPromise = function(userId, password) {
            /*eslint-disable camelcase*/
            var data = {
                j_username: userId,
                j_password: password
            };

            /*eslint-enable */

            return $http.post(config.loginUrl, lpCoreUtils.buildQueryString(data), {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/x-www-form-urlencoded;',
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Pragma': 'no-cache',
                    'Expires': '0',
                    'X-BBXSRF' : ''
                }
            });
        };

        this.sessionAlive = function () {
            return $http.get(config.sessionAlive).then(function (success) {
                localStorage.setItem("token", success.headers('X-BBXSRF'));
            }, function (error) {
                localStorage.setItem("token", error.headers('X-BBXSRF'));
            });
        };

        /**
         * Authentication and OTP access
         */
        this.verifyPreAuthentication = function(userId, password, token) {

            return $q(function (resolve, reject) {
                var data = {
                    j_username: userId,
                    j_password: password
                };
                $http.post(config.loginUrl, lpCoreUtils.buildQueryString(data), {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/x-www-form-urlencoded;',
                        'Cache-Control': 'no-cache, no-store, must-revalidate',
                        'Pragma': 'no-cache',
                        'Expires': '0'
                    }
                }).then(function(response){
                    self.error = null;
                    resolve(response);
                },function(response){
                    self.error = response.data.errors[0].code;
                    reject(response);
                });

            });

        };

        this.verifyOtp = function (userOtp, isFirstTime) {
          var payload, url;

          if(isFirstTime) {
            url = config.otpBindUrl;
            payload = {
              vascoChallenge: userOtp
            }
          } else {
            url = config.otpValidationUrl;
            payload = {
              otp: userOtp
            }
          }
            return $q(function (resolve, reject) {
                $http.post(url, payload).then(function (success) {
                    resolve(success);
                }, function (error) {
                    reject(error);
                })

            });
        };

        this.verifyOTPBindedWithAccount = function(){
            return $q(function (resolve, reject) {
                $http.post(config.optActivationUrl).then(function(response){
                    self.error = null;
                    if(response.data)
                      resolve(response);
                },function(response){
                    self.error = response.data.errors[0].code;
                    reject(response);
                });

            });
        };

        this.setPassword = function (newPassword) {
            var payload = {
                newPassword: newPassword
            };

            return $q(function (resolve, reject) {
                $http.post(config.setPasswordUrl, payload).then(function (success) {
                    resolve(success);
                }, function (error) {
                    reject(error);
                })

            });
        };

        this.getQrCode = function (token) {
            return $q(function (resolve, reject) {
                $http.get(config.getQrUrl, {
                    headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/x-www-form-urlencoded;',
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Pragma': 'no-cache',
                    'Expires': '0',
                    'X-BBXSRF' : token
                }}).then(function (success) {
                    resolve(success);
                }, function (error) {
                    reject(error);
                });
            });
        };

        this.bindOtp = function () {
          return $q(function (resolve, reject) {
            $http.post(config.otpBindUrl).then(function (success) {
              resolve(success);
            }, function (error) {
              reject(error);
            });
          });
        };

        this.getUserStatus = function () {
          return $q(function (resolve, reject) {
            $http.get(config.userStatusUrl).then(function (success) {
              resolve(success);
            }, function (error) {
              reject(error);
            });
          });
        };

        this.logout = function(token,redirect){

            var data = {
                BBXSRF: token,
                portal_name: lpPortal.name,
                page_name: lpPortal.page.name
            };

            if(redirect === true){
              data.redirect = '/portalserver/'+lpPortal.name+'/sign-in';
            }

            $window.sessionStorage.clear();

            $http.post(config.logoutUrl, lpCoreUtils.buildQueryString(data),{
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/x-www-form-urlencoded;',
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Pragma': 'no-cache',
                    'Expires': '0'
                }
            }).then(function (response) {
                if(redirect)
                      $window.location.href = lpPortal.root +'/'+lpPortal.name+ '/sign-in';
                }, function (response) {
            });

        };

    };
});



//////////////////
// WEBPACK FOOTER
// ./scripts/login-service.js
// module id = 9
// module chunks = 0